import React from 'react';
import { useBookingStatuses } from '../../../../../../utilities/hooks/useBookingStatuses';
import { useDictionary } from '../../../../../../utilities/hooks/UseDictionary';
import { UseCurrencyDecorator } from '../../../../../../utilities/hooks/UseCurrencyDecorator';
import PropTypes from 'prop-types';
import { ReactComponent as ClockIcon } from '../../../../../../assets/icons/ic_clock.svg';
import {AmountFormatHelper} from "../../../../../../utilities/helpers/AmountFormatHelper";
import ProfileImage from '../../../../common/ProfileImage';

const SlotBookingItem = ({ booking, onBookingClicked }) => {
	const bookingStatuses = useBookingStatuses();
	const dictionary = useDictionary();
	const currencyDecorator = UseCurrencyDecorator();

	const getBookingStatus = (status) => {
		return (
			<div
				className={'booking-status ' + bookingStatuses[status].class}
				data-testid={'booking-status'}
			>
				{bookingStatuses[status].text}
			</div>
		);
	};

	const getPaymentStatus = (status) => {
		if (status === 'paid') {
			return (
				<div className="booking-customer-container">
					<div className="booking-status-paid-icon" />
					<div>{dictionary.paid}</div>
				</div>
			);
		} else if (status === 'refunded') {
			return (
				<div className="booking-customer-container">
					<div className="booking-status-refunded-icon" />
					<div>{dictionary.refunded}</div>
				</div>
			);
		} else if (status === 'pending') {
			return (
				<div className="booking-customer-container">
					<div className="booking-status-pending-icon">
						<ClockIcon />
					</div>
					<div>{dictionary.pending}</div>
				</div>
			)
		} else if (status === 'failed') {
			return (
				<div className="booking-customer-container">
					<div className="booking-status-unpaid-icon"></div>
					<div>{dictionary.failed}</div>
				</div>
			);
		} else if (status === 'partial_refunded') {
			return (
				<div className="booking-customer-container">
					<div className="booking-status-refunded-icon" />
					<div>{dictionary.partial_refunded}</div>
				</div>
			);
		}
		return (
			<div className="booking-customer-container">
				<div className="booking-status-unpaid-icon" />
				<div>{dictionary.no_charge}</div>
			</div>
		);

	};

	const getParticipantsQuantity = () => {
		let quantity = 0;
		booking?.participants.map((group) => {
			quantity += group.quantity;
		});

		return quantity + ' ' + (quantity > 1 ? dictionary.spots : dictionary.spot);
	};

	return (
		<tr
			className="slot-booking-container"
			key={booking.id}
			onClick={() => onBookingClicked(booking)}
			data-testid="slot-booking-container"
		>
			<td>
				<div className="booking-number" data-testid="booking-number">
					{booking.display_id}
				</div>
			</td>
			<td>{getBookingStatus(booking.status.value)}</td>
			<td>
				<div
					className="booking-customer-container"
					data-testid="booking-customer-name"
					style={{gap: '8px'}}
				>
					<ProfileImage name={booking.customer.name} photo={booking?.customer?.avatar_url} size={{width: 24, height: 24, fontSize: 11, lineHeight: 14}}/>
					<div className='truncate admin-booking-customer-name' title={booking.customer.name}>{booking.customer.name}</div>
				</div>
			</td>
			<td>
				<div
					data-testid="booking-participants-quantity"
					className="booking-participants-quantity"
				>
					<div>{getParticipantsQuantity()}</div>
				</div>
			</td>
			<td>{getPaymentStatus(booking.payment_status.value)}</td>
			<td>
				<div className="booking-price" data-testid="booking-price">
					{currencyDecorator(AmountFormatHelper.formatAmount(booking.amount), booking.currency)}
				</div>
			</td>
		</tr>
	);
};

SlotBookingItem.propTypes = {
	booking: PropTypes.object,
	onBookingClicked: PropTypes.func
};

export default SlotBookingItem;
